import { ModelBase } from 'store/model-base';

export class EsimChange extends ModelBase {
    public static storeName: string = 'esimChange';

    public orderKey: string;
    public orderNumber: string;
}
